import { List, ListItem } from "@mui/material";
import { Rasteplass } from "../../services/RuteplanAPI";
import { IRoutePartProps } from "./RouteDescription";
import rasteplassIconSource from "../../assets/restingarea.svg"

export default function Rasteplasser(props: IRoutePartProps) {

    return (       
        <>
            {props.roadFeatures && props.roadFeatures.rasteplasser && props.roadFeatures.rasteplasser.length > 0 &&
            <List>
                {props.roadFeatures.rasteplasser.map( (rasteplass: Rasteplass, index: number) => {
                    return <ListItem 
                        key={rasteplass.navn + index} 
                        className="roadFeature" 
                        onClick={(event) => {props.onClick(rasteplass, event)}}
                        onMouseEnter={() => props.onMouseEnterItem(rasteplass)}
                        onMouseLeave={props.onMouseLeaveItem}>
                            <img src={rasteplassIconSource} height="24"  style={{paddingRight:"5px"}} alt="Rasteplass icon" title="rasteplassIcon"/> 
                            {rasteplass.navn}
                    </ListItem>
                })}
            </List>        
            }
        </> 
    )
}